// extracted by mini-css-extract-plugin
module.exports = {"container":"ResumeDisplay_container__1Z802","noEdit":"ResumeDisplay_noEdit__ly20t"};